import { render } from "./Variant_Transcripts.vue?vue&type=template&id=a6a2675a"
import script from "./Variant_Transcripts.vue?vue&type=script&lang=js"
export * from "./Variant_Transcripts.vue?vue&type=script&lang=js"

import "./Variant_Transcripts.vue?vue&type=style&index=0&id=a6a2675a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__